import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpResponse,
  HttpEvent,
  HttpErrorResponse
} from "@angular/common/http";
import { LoaderService } from "./services/loader.service";
import { catchError, finalize, tap } from "rxjs/operators";
import { Observable, throwError } from "rxjs";

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // this.loaderService.show();

    // return next.handle(req).pipe(
    //   finalize(() => this.loaderService.hide())
    // );

    // Handle offline scenario
    if (!navigator.onLine) {
      sessionStorage.setItem('serverDown', 'true');
      return throwError(() => ({
        message: 'Please make sure you are connected to the internet.',
        error: {
          error: 'Please make sure you are connected to the internet.',
          message: 'Please make sure you are connected to the internet.'
        }
      }));
    }
    this.loaderService.show();
    return next.handle(req).pipe(
      tap(event => {
        // This is called for every HttpEvent
        // We want to check if it's an HttpResponse (successful response)
        if (event instanceof HttpResponse) {
          // Server responded successfully, clear serverDown flag
          sessionStorage.setItem('serverDown', 'false');
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (!error.status || error.status >= 500 || error.status === 0) {
          sessionStorage.setItem('serverDown', 'true');
          return throwError(() => ({
            message: 'Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.',
            error: {
              error: 'Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.',
              message: 'Sorry, the server is currently undergoing maintenance. Please try again later. We apologize for any inconvenience.'
            }
          }));
        } else {
          // For other errors, forward the original error object or customize as needed
          return throwError(() => error);
        }
      }),
      finalize(() => {
        this.loaderService.hide();
      })
    );
  }
}
